<template>
  <div>
    <v-snackbar
      v-model="show"
      bottom
      multi-line
      right
      v-if="el === 'snackbar' && notification !== null"
    >
      {{ notification.msg }}
      <v-btn
        color="primary"
        flat
        @click="closeNotification"
      >
        Schließen
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import notificationHandler from '../../../services/notificationHandler';

export default {
  name: 'notification',

  data() {
    return {
      el: null,
      mode: null,
      show: false,
    };
  },

  computed: {
    notification() {
      return this.$store.app.state.notification;
    },
  },

  watch: {
    notification() {
      if (this.notification !== null) {
        const types = this.notification.type.split(':');
        this.el = types[0];
        this.mode = types[1];
        this.show = true;
      }
    },
  },

  methods: {
    closeNotification() {
      this.show = false;
      notificationHandler.closeNotification();
    },
  },
};
</script>
